/**
 * Catalog import query keys. The preview is never cached (it is a mutation:
 * its answer depends on the whole body and is replaced on every re-check), so
 * only the history reads have keys: a branch's list, its pages, and one
 * record. Invalidating `list(branchId)` refetches every cached page of it.
 */
export const CatalogImportQueryKeys = {
    all: ['catalogImports'] as const,
    lists: () => [...CatalogImportQueryKeys.all, 'list'] as const,
    /** One branch's history; `null` is every branch (OrgAdmin only). */
    list: (branchId: string | null) =>
        [...CatalogImportQueryKeys.lists(), branchId] as const,
    /** One page of a branch's history, under `list(branchId)`. */
    listPage: (branchId: string | null, page: number, pageSize: number) =>
        [...CatalogImportQueryKeys.list(branchId), page, pageSize] as const,
    detail: (id: string) =>
        [...CatalogImportQueryKeys.all, 'detail', id] as const,
};
